<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense>
						<v-col cols="1">
							<v-select :items="selectColList" v-model="query.colId"
							item-text="colName" item-value="id" label="栏目" dense outlined></v-select>
						</v-col>
						<v-col cols="1">
							<v-text-field clearable dense label="标题名称" outlined v-model="query.caption">
							</v-text-field>
						</v-col>
						<v-col cols="1">
							<v-select :items="statusItems" v-model="query.status"
							item-text="name" item-value="id" label="状态" dense outlined></v-select>
						</v-col>
						<v-col cols="1">
							<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
								</v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="1">
							<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="结束日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
								</v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="7">
							<v-btn @click="queryClicked" color="primary">查询</v-btn>
						</v-col>
						<v-col cols="12">
							<v-btn small @click="$router.push('/content/article/create')" color="info">添加文章</v-btn>
						</v-col>
					</v-row>
				</template>
				<template v-slot:item.status="{item}">
					<v-chip small :color="statusColor(item.status)">{{ statusName(item.status) }}
					</v-chip>
				</template>
				<template v-slot:item.coverImg="{item}">
					
					<v-img v-if="item.coverImg" :src="imgPrev + item.coverImg" :aspect-ratio="15/4" width="375" class="mt-1 mb-1" ></v-img>
					
				</template>
				
				<template v-slot:item.action="{item}">
					<v-btn @click.stop="toEdit(item)" color="primary" x-small>修改</v-btn>
					<v-btn @click.stop="frozenArticle(item)" :disabled="item.status !== '1'" color="error" class="ml-3" x-small>作废</v-btn>
					<v-btn @click.stop="freeArticle(item)" :disabled="item.status === '1'" color="success" class="ml-3" x-small>启用</v-btn>
					
				</template>

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="2" >
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9"   v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>
		
	</v-card>
</template>

<script>
	
	import global from '../../../config/global'
	export default {
		name: "article-list",
		data() {
			return {
				imgPrev: global.config.imgPre,
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '内容管理',
						disabled: true
					},
					{
						text: '文章列表',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '栏目',
							value: 'colName',
							sortable: false,
							width:'300'
						},
						{
							text: '标题',
							value: 'caption',
							sortable: false,
							width:'400'
						},
						{
							text: '封面',
							value: 'coverImg',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				selectColList:[], //选择栏目数据源
				statusItems:[{id:"1",name:'正常'},{id:"0",name:'作废'}],
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					caption: "",
					colId: "",
					status:"1"
				},
				
				
			}
		},
		created() {
			// 获取门店列表
			this.getColListForSelect();
			this.getTableDataList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			toEdit(item){
				this.$router.push({path:'/content/article/edit',query:{id:item.id}});
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},	
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/content/article/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.caption) {
					url += "&caption=" + this.query.caption;
				}
				if (this.query.colId) {
					url += "&colId=" + this.query.colId;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			
			showUpdate(item) {
				this.update.dialog = true;
				this.update.class.id = item.id;
				this.update.class.shopId = item.shopId;
				this.update.class.className = item.className;
				this.update.class.courseId = item.courseId;
		
				this.update.class.maxQty = item.maxQty;
				
				// 加载课程和教师
				this.getCourseListForSelect(this.update.class.shopId);
				
			},
			submitUpdateClass() {

				if (!this.update.class.shopId) {
					this.$noty.error('校区不能为空');
					return
				}
				if (!this.update.class.className) {
					this.$noty.error('班级名称不能为空');
					return
				}
	
				
				// api
				const that = this;
				let url = `/edu/class/update`;
			
				// parameters
				
				const updateData = {
					...this.update.class
				}
				
				this.axios.post(url, updateData).catch(() => {
						that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.update.dialog = false;
							that.getTableDataList();
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});
			},
			frozenArticle(item){
				//冻结
				const that = this;
				let url = `/content/article/frozen/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			freeArticle(item){
				//冻结
				const that = this;
				let url = `/content/article/free/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			getColListForSelect(){
				const that = this;
				let url = `/content/col/list`;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectColList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		},
		
	}
</script>

<style>
</style>
